// @flow

import type { Node } from "react";
import React from "react";

import { classNameOf } from "@/utils";
import JsonPageRenderer from "@/utils/JsonPageRenderer/JsonPageRenderer";
import type { ItemRenderer, PageItem, RenderChildrenFn } from "@/utils/JsonPageRenderer/types";

interface SectionPageItem extends PageItem {
    props: {
        [string]: any,
        className?: string,
    };
}

/**
 * Transforms a SectionPageItem into a <section> node.
 */
class SectionRenderer implements ItemRenderer<SectionPageItem> {
    render(
        context: JsonPageRenderer,
        item: SectionPageItem,
        renderChildren: RenderChildrenFn,
    ): Node {
        const className = classNameOf(
            "py-1",
            "py-md-3",
            item.props.className || "",
        );
        return (
            <section key={item.id} className={className}>
                {renderChildren(item.children)}
            </section>
        );
    }

    match(item: PageItem): SectionPageItem | null {
        if (item.type === "section") {
            return item;
        }
        return null;
    }
}

export default SectionRenderer;
